import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService, TranslateParams } from '@core/services/translate.service';

@Pipe({
  name: 'translate',
  pure: true,
})
export class TranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(key: string, params?: TranslateParams): string {
    return this.translateService.translate(key, params);
  }
}
